<template>
  <fb-list-body
      :pager="pager"
      :showSearchForm="false"
      :showBtnGroup="true"
      @handlePagerSizeChange="handlePagerSizeChange"
      @handlePagerIndexChange="handlePagerIndexChange"
  >
    <template slot="btn-group">
      <el-button icon="el-icon-plus" @click="$router.push('/offline-recipes-add')">{{ $t('lang.新增') }}</el-button>
      <el-button icon="el-icon-delete" @click.native="handleBatchDelete">{{ $t('lang.删除') }}</el-button>
    </template>

    <template slot="table">
      <el-row :gutter="24">
        <el-col :span="4">
          <div class="menu-box">
            <span class="menu-title">{{ $t('lang.型号') }}</span>

            <el-menu :default-active="menuActive" @select="handleClickRow" @open="handleOpenMenu"
                     :default-openeds="openeds">

              <template v-for="(item, index) in productTree">

                <el-submenu :index="index + ''" class="menu-item" :key="index" v-if="item.products.length">
                  <template slot="title">
                    <span>{{ item.subBrandName }}</span>
                  </template>

                  <template v-for="(second, idx) in item.products">
                    <el-menu-item :key="index +'_second_' + idx" :index="index + '-' + idx" class="submenu-item">
                      {{ second.subModel }}
                    </el-menu-item>
                  </template>

                </el-submenu>

                <el-menu-item :index="index + ''" class="menu-item" :key="index" v-else>
                  <span slot="title">{{ item.subBrandName }}</span>
                </el-menu-item>

              </template>


            </el-menu>

          </div>

        </el-col>

        <el-col :span="20">
          <el-table
              :data="tableData"
              @selection-change="handleSelectionChange"
              border
          >
            <el-table-column type="selection" width="50"></el-table-column>

            <el-table-column type="index" width="50"></el-table-column>
            <el-table-column prop="number" :label="$t('lang.离线食谱包编号')"></el-table-column>
            <el-table-column prop="productModel" :label="$t('lang.型号')"></el-table-column>
            <el-table-column prop="recipeCount" :label="$t('lang.食谱数量')"></el-table-column>
            <el-table-column prop="typeName" :label="$t('lang.菜谱包类型')">
              <template v-slot="{row}">
                {{$t(`lang.${row.typeName}`)}}
              </template>
            </el-table-column>
            <el-table-column prop="testStatusName" :label="$t('lang.测试状态')">
              <template v-slot="{row}">
                {{$t(`lang.${row.testStatusName}`)}}
              </template>
            </el-table-column>
            <el-table-column prop="releaseStatusName" :label="$t('lang.上线状态')">
              <template v-slot="{row}">
                {{$t(`lang.${row.releaseStatusName}`)}}
              </template>
            </el-table-column>
            <el-table-column prop="createTimeStr" :label="$t('lang.创建时间')"></el-table-column>

            <el-table-column fixed="right" :label="$t('lang.操作')" width="420">
              <template slot-scope="scope">
                <el-button size="mini"
                           @click="$router.push({path: '/offline-recipes-edit',query: { code: scope.row.code }})" plain
                           type="primary">{{ $t('lang.编辑') }}
                </el-button>
                <el-button size="mini"
                           @click="handleChangeTestStatus(scope.row)" plain
                           type="primary">
                  {{ scope.row.testStatus != 'running' ? $t('lang.发布测试') : $t('lang.取消测试') }}
                </el-button>
                <el-button
                    size="mini"
                    @click="handleChangeRelease(scope.row)" plain type="primary">
                  {{ scope.row.releaseStatus != 'release' ? $t('lang.发布上线') : $t('lang.取消上线') }}
                </el-button>

                <el-button
                    size="mini"
                    @click="handleDownloadFile(scope.row)" plain type="primary">{{ $t('lang.下载') }}
                </el-button>
                <el-button size="mini" plain type="danger" @click="handleDelete(scope.row)">{{ $t('lang.删除') }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </template>
  </fb-list-body>
</template>

<script>
import {downloadFile} from "../../js/common";

export default {
  name: "OfflineRecipesList",
  components: {},
  props: {
    timestamp: {
      type: Number,
      default: function () {
        return new Date().getTime();
      }
    }
  },
  data() {
    return {
      api: {
        list: this.$api.offlineRecipes.list,
        delete: this.$api.offlineRecipes.delete,
        batchDelete: this.$api.offlineRecipes.batchDelete,
        updateReleaseStatus: this.$api.offlineRecipes.updateReleaseStatus,
        updateTestStatus: this.$api.offlineRecipes.updateTestStatus,
      },
      searchForm: {
        brandOwnerCode: this.$store.state.userInfo['brandOwnerCode'],
        productCode: '',
        subBrandProductCode: ''
      },
      tableData: [],
      selection: [],
      pager: {
        pageSize: 10,
        pageIndex: 1,
        itemCount: 0
      },
      openeds: [],
      menuActive: '0',
    };
  },
  computed: {
    searchParams() {
      return Object.assign({}, this.$route.query, this.searchForm, this.pager);
    },
    productTree() {
      const vm = this;
      let list = this.$store.state.brandProductTree;
      list.forEach((i, index) => {
        vm.openeds.push(index);
      });
      if (list.length && list[0].products.length) {
        vm.menuActive = '0-0';
      } else {
        vm.menuActive = '0';
      }
      return list;
    }
  },
  watch: {
    menuActive: {
      handler(val) {
        this.handleClickRow(val)
      },
      immediate: true,
      deep: true,
    },
    timestamp() {
      // this.handleSearch();
    },
    "pager.pageIndex": {
      handler() {
        this.$router.updateQuery({
          path: this.$route.path,
          query: this.searchParams
        });
        this.handleSearch();
      },
      deep: true,
      immediate: true
    },
    "pager.pageSize": {
      handler() {
        this.$router.updateQuery({
          path: this.$route.path,
          query: this.searchParams
        });
        this.handleSearch();
      },
      deep: true
    }
  },
  methods: {
    handleChangeTestStatus(row) {
      let vm = this;
      let text = row.testStatus != 'running' ? '发布测试' : '取消测试';

      vm.$confirm(vm.$t(`lang.您现在正在进行${text}操作`), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: "warning"
      }).then(() => {
        let data = {
          code: row.code,
          testStatus: row.testStatus != 'running' ? 'running' : 'not_start',
        }
        vm.$http.get(vm.api.updateTestStatus, {params: data}).then(resp => {
          if (resp.data.status === 200) {
            vm.$message({
              type: "success",
              message: resp.data.desc
            });
            vm.handleSearch();
          } else {
            vm.$message({
              type: "error",
              message: resp.data.desc
            });
          }
        });
      })
    },
    handleChangeRelease(row) {
      let vm = this;
      let text = row.releaseStatus != 'release' ? '发布上线' : '取消上线';

      vm.$confirm(vm.$t(`lang.您现在正在进行${text}操作`), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: "warning"
      }).then(() => {
        let data = {
          code: row.code,
          releaseStatus: row.releaseStatus != 'release' ? 'release' : 'not_release',
        }
        vm.$http.get(vm.api.updateReleaseStatus, {params: data}).then(resp => {
              if (resp.data.status === 200) {
                vm.$message({
                  type: "success",
                  message: resp.data.desc
                });
                vm.handleSearch();
              } else {
                vm.$message({
                  type: "error",
                  message: resp.data.desc
                });
              }
            });
      })
    },


    handleDownloadFile(row) {
      if(!row.fileCode) {
        this.$message.warning('正在打包中……');
        return;
      }
      downloadFile(this, row.fileCode);
    },
    handleClickRow(e) {
      let index = e.split('-');
      let item = this.productTree[index[0]];
      if (index.length > 1) {
        let subItem = item.products[index[1]];
        this.searchForm['subBrandProductCode'] = subItem.code;
        this.searchForm['productCode'] = '';
      } else {
        this.searchForm['productCode'] = item.code;
        this.searchForm['subBrandProductCode'] = '';
      }
      this.tableData = [];
      this.pager.pageIndex = 1;
      this.pager.pageSize = 10;
      this.pager.itemCount = 0;
      this.handleSearch();
    },

    handleOpenMenu(index) {
      this.handleClickRow(index);
    },

    handleEdit(e) {
      if (e && e.code) {
        this.$router.push({
          path: "edit",
          query: {
            code: e.code
          }
        });
        return;
      }

      if (!this.selection.length) {
        this.$message({
          type: "warning",
          message: this.$t('lang.未选择记录')
        });
        return;
      }

      if (this.selection.length > 1) {
        this.$message({
          type: "warning",
          message: this.$t('lang.一次只能编辑一条数据')
        });
        return;
      }

      this.$router.push({
        path: "edit",
        query: {
          code: this.selection[0].code
        }
      });
    },
    handleDelete(row) {
      let vm = this;

      vm.$confirm(vm.$t('lang.您现在正在进行删除操作'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: "warning"
      })
          .then(() => {
            vm.$http
                .post(
                    vm.api.delete,
                    vm.$qs.stringify({
                      code: row.code
                    })
                )
                .then(resp => {
                  if (resp.data.status === 200) {
                    vm.$message({
                      type: "success",
                      message: resp.data.desc
                    });
                    vm.handleSearch();
                  } else {
                    vm.$message({
                      type: "error",
                      message: resp.data.desc
                    });
                  }
                });
          })
          .catch(() => {
            // this.$message({
            //     type: 'info',
            //     message: '已取消删除'
            // });
          });
    },
    handleBatchDelete() {
      let vm = this;

      if (!this.selection.length) {
        this.$message({
          type: "warning",
          message: vm.$t('lang.未选择记录')
        });
        return;
      }

      let codes = [];

      this.selection.forEach(e => {
        codes.push(e.code);
      });

      this.$confirm(vm.$t('lang.您现在正在进行删除操作'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: "warning"
      })
          .then(() => {
            vm.$http.post(this.api.batchDelete, codes).then(resp => {
              if (resp.data.status === 200) {
                vm.$message({
                  type: "success",
                  message: resp.data.desc
                });
                vm.handleSearch();
              } else {
                vm.$message({
                  type: "error",
                  message: resp.data.desc
                });
              }
            });
          })
          .catch(() => {
            // this.$message({
            //     type: 'info',
            //     message: '已取消删除'
            // });
          });
    },
    handleSelectionChange(selection) {
      console.log(selection);
      this.selection = selection;
    },
    handlePagerSizeChange(e) {
      this.pager.pageSize = e;
    },
    handlePagerIndexChange(e) {
      this.pager.pageIndex = e;
    },
    handleSearch() {
      let vm = this;
      if(!this.searchParams.productCode && !this.searchParams.subBrandProductCode) return;
      this.$http
          .post(this.api.list, this.$qs.stringify(this.searchParams))
          .then(resp => {
            for (let key in resp.data.data) {
              if (resp.data.data[key] instanceof Array) {
                vm.tableData = resp.data.data[key];
              }
            }

            //处理分页
            // vm.pager.pageIndex = resp.data.data.pager.pageIndex;
            // vm.pager.pageSize = resp.data.data.pager.pageSize;
            vm.pager.itemCount = resp.data.data.pager.itemCount;
          });
    }
  },
  created() {
    for (let key in this.searchForm) {
      if (this.$route.query[key]) {
        this.searchForm[key] = this.$route.query[key];
      }
    }
  }
};
</script>

<style scoped>

.menu-box {
  width: 100%;
  background: #eee;
}

.menu-title {
  display: inline-block;
  width: 100%;
  font-size: 14px;
  line-height: 40px;
  background: #f5f5f5;
  box-sizing: border-box;
  padding-left: 16px;
  border: 1px solid #ddd;
  border-bottom: 0px;
}

.menu-item {
  border: 1px solid #ddd;
  border-top: 0px;
}

.submenu-item {
  border-top: 1px solid #ddd;
}


.el-menu-item.is-active {
  background: #81b6ec;
  color: #ffffff;
}

/deep/ .el-submenu .el-menu-item {
  min-width: 0;
}


</style>
